/**
 * Avatar-Baukasten: enumerierte Part-IDs sind die persistierte Wahrheit
 * (users.avatar als JSON). Die Zuordnung zu konkreten Farben/Formen liegt
 * beim Client-Theme — dieselbe Trennung wie bei Tile-IDs vs. Tile-Optik.
 */
export const AVATAR_SKIN_TONES = ['hell', 'beige', 'oliv', 'braun', 'dunkel'];
export const AVATAR_HAIR_STYLES = ['glatze', 'kurz', 'bob', 'dutt', 'locken', 'irokese'];
export const AVATAR_HAIR_COLORS = ['schwarz', 'braun', 'blond', 'rot', 'grau', 'blau'];
export const AVATAR_OUTFIT_COLORS = [
    'koralle',
    'teal',
    'lavendel',
    'honig',
    'gruen',
    'himmel',
    'pink',
    'graublau',
];
export const AVATAR_ACCESSORIES = ['keins', 'brille', 'sonnenbrille', 'hut', 'muetze', 'kopfhoerer'];
//# sourceMappingURL=avatar.js.map